import styled from "styled-components";

import { DetailPanel } from "@/components/organisms";
import { breakpoints } from "@/styles/breakpoints";

export const StyledClaimFolder = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 6px;
    margin: 10px 5px;

    @media ${breakpoints.xs} {
        margin: 10px 0;
    }

    background: var(--color-white);
    border-radius: var(--radius-10);

    .folderTitle {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 5px 10px 10px 10px;
        margin: 0;
        font-weight: bold;
        color: var(--color-primary);
        border-bottom: 1px solid var(--color-grey-700);

        p {
            margin: 0;
        }

        .contentPanel {
            background: var(--color-grey-400);
        }
    }
`;

export const StyledDetailPanelStakeholders = styled(DetailPanel)`
    .contentPanel .infoContainer .valueWrap svg {
        width: 20px;
        height: 20px;
        margin-right: 5px;
        align-self: center;
    }
`;
